/* Collection automatic progressive loading — replaces a manual "click to
   load more" interaction with an IntersectionObserver that fires the same
   fetch on its own once the customer scrolls near the trigger, without
   inventing a new pagination system: every fetch still just follows
   Shopify's own paginate.next.url (see collection-template.liquid), which
   already carries the current filter/sort query string, so filtered and
   sorted views keep working with zero extra logic here.

   The trigger is a real <a href="paginate.next.url">, not a bare button —
   with JS disabled it's a genuine, crawlable, working pagination link
   (rel="next" pagination stays real and usable without any JS at all);
   with JS enabled, clicks are also intercepted so a customer who does
   click it gets the same in-place append instead of a full navigation.

   The address bar is deliberately left on the original URL throughout —
   an earlier version called history.replaceState(url) to point it at
   paginate.next.url after each load, but that URL is a real Shopify page
   in its own right showing only that one page's products (e.g.
   /collections/all?page=2 renders page 2's products alone, not page 1 +
   page 2 together). Refreshing while pointed at it showed noticeably
   fewer/different products than the visitor had already scrolled
   through. Leaving the URL alone means a refresh reloads the original
   (page 1) view — the standard, expected behaviour for this pattern. */
(function () {
  'use strict';

  var isLoading = false;
  var observer = null;

  function setEndOfResults(link) {
    var wrapper = link.parentNode;
    var end = document.createElement('p');
    end.className = 'mbg-load-more__end';
    end.textContent = "You've reached the end.";
    wrapper.replaceChild(end, link);
  }

  function loadNext(link) {
    if (isLoading) {
      return;
    }
    var url = link.getAttribute('href');
    if (!url) {
      return;
    }
    var grid = document.getElementById('MbgProductGrid');
    if (!grid) {
      return;
    }

    isLoading = true;
    link.setAttribute('aria-busy', 'true');
    var originalText = link.textContent;
    link.textContent = 'Loading…';

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Load more request failed');
        }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('MbgProductGrid');
        if (nextGrid) {
          // Move each fetched card into the live grid one at a time
          // (not innerHTML += ) so no markup is re-parsed or duplicated,
          // and lazysizes' own MutationObserver sees each real node land.
          Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
            grid.appendChild(child);
          });
        }

        var nextLink = doc.querySelector('[data-mbg-load-more-button]');
        isLoading = false;
        link.removeAttribute('aria-busy');

        if (nextLink && nextLink.getAttribute('href')) {
          link.setAttribute('href', nextLink.getAttribute('href'));
          link.textContent = originalText;
        } else {
          if (observer) {
            observer.unobserve(link);
          }
          setEndOfResults(link);
        }

        if (window.mbgModelView) {
          window.mbgModelView.apply(false);
        }
      })
      .catch(function () {
        isLoading = false;
        link.removeAttribute('aria-busy');
        link.textContent = originalText;
      });
  }

  // Manual click still works (e.g. a customer who clicks before the
  // observer fires, or clicks right after a failed fetch) — same in-place
  // append, no full navigation, while the plain href keeps working with
  // JS disabled.
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-mbg-load-more-button]');
    if (!link) {
      return;
    }
    evt.preventDefault();
    loadNext(link);
  });

  var trigger = document.querySelector('[data-mbg-load-more-button]');
  if (trigger && 'IntersectionObserver' in window) {
    // rootMargin extends the trigger zone well below the actual viewport
    // so the next page loads while the customer is still approaching the
    // last loaded row, not only once the link itself becomes visible.
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNext(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px 800px 0px' }
    );
    observer.observe(trigger);
  }
})();
